'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = require('react-redux');

var _heroBanner = require('../../redux/selectors/heroBanner');

var selectors = _interopRequireWildcard(_heroBanner);

var _componentHelpers = require('../../utils/component-helpers');

var _gridProps = require('./gridProps');

var _buttonProps = require('./buttonProps');

var _HeroBanner = require('acq-components/lib/composite-components/HeroBanner/HeroBanner');

var _SbsPrimaryContainer = require('acq-components/lib/composite-components/HeroBanner/variants/IntlCommercial/SbsPrimaryContainer');

var _SbsSecondaryContainer = require('acq-components/lib/composite-components/HeroBanner/variants/IntlCommercial/SbsSecondaryContainer');

var _FullWidthBackground = require('acq-components/lib/composite-components/FullWidthBackground/FullWidthBackground');

var _ApplyModal = require('../ApplyModal/ApplyModal');

var _ApplyModal2 = _interopRequireDefault(_ApplyModal);

var _dtmConsts = require('acq-components/lib/utils/DTM/dtmConsts');

var _dtmEvent = require('acq-components/lib/utils/DTM/dtmEvent');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardDetailsHeroBannerBusiness = function CardDetailsHeroBannerBusiness(_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$dtmHelper = _ref.dtmHelper,
      dtmHelper = _ref$dtmHelper === undefined ? {} : _ref$dtmHelper,
      props = (0, _objectWithoutProperties3.default)(_ref, ['styles', 'dtmHelper']);

  if (!props.hasHeroBannerData) return null;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      showModal = _useState2[0],
      setModalState = _useState2[1];

  var openModal = function openModal() {
    return setModalState(true);
  };
  var closeModal = function closeModal() {
    return setModalState(false);
  };

  var primaryButton = props.primaryButton && (0, _buttonProps.buildButtonProps)({
    buttonData: props.primaryButton,
    customClass: !props.secondaryButton && (0, _lodash2.default)(styles.hero, 'button--noMargin'),
    dtmAction: _dtmConsts.DTM_CONSTS.actionApplyNow,
    styles: styles,
    dtmHelper: dtmHelper,
    buttonKey: props.primaryButton.key,
    cardShortName: props.cardShortName,
    openModal: openModal
  });

  var secondaryButton = props.secondaryButton && (0, _buttonProps.buildButtonProps)({
    buttonData: props.secondaryButton,
    dtmAction: _dtmConsts.DTM_CONSTS.actionSpeakToSpecialist,
    styles: styles,
    dtmHelper: dtmHelper,
    buttonKey: props.secondaryButton.key,
    cardShortName: props.cardShortName,
    openModal: openModal
  });

  var onClickHandler = function onClickHandler() {
    (0, _dtmEvent.triggerDTMEvent)({
      eventAction: props.termAndConditionsLink.dtm && props.termAndConditionsLink.dtm.eventAction,
      eventAsset: props.cardShortName + '-' + (props.termAndConditionsLink.dtm && props.termAndConditionsLink.dtm.eventAsset)
    });
    (0, _componentHelpers.openInNewTab)(dtmHelper.getUrlByLinkObj(props.termAndConditionsLink, _dtmConsts.DTM_CONSTS.hero));
  };
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      _FullWidthBackground.FullWidthBackground,
      {
        styles: styles.fullWidthBackground,
        isDarkShade: true,
        isImageRepeated: true,
        backgroundImgUrl: props.background.url,
        backgroundImgHeight: '180px',
        custClassName: 'hero-banner ' + props.cardShortName
      },
      _react2.default.createElement(_HeroBanner.HeroBanner, {
        PrimaryContentComponent: _SbsPrimaryContainer.SbsPrimaryContainer,
        SecondaryContentComponent: _SbsSecondaryContainer.SbsSecondaryContainer,
        styles: styles.hero,
        primaryContentProps: {
          image: {
            src: props.cardImage.url,
            alt: props.cardImage.alt
          },
          styles: styles.hero,
          buttonsContainerClassname: styles.hero.buttonsContainer,
          primaryButtonProps: primaryButton,
          secondaryButtonProps: secondaryButton,
          textComponents: {
            phoneNumber: props.phoneNumberLink && (0, _componentHelpers.concatPhone)(props.phoneNumberLink),
            tncLink: props.termAndConditionsLink && props.termAndConditionsLink.title
          },
          textComponentsStyles: {
            phoneNumber: (0, _lodash2.default)(styles, 'hero.phoneNumber'),
            tncLink: (0, _lodash2.default)(styles, 'hero.tncLink')
          },
          textComponentsProps: {
            tncLink: {
              onClick: onClickHandler
            }
          },
          gridProps: (0, _gridProps.gridProps)(styles, props)
        },
        secondaryContentProps: (0, _gridProps.gridProps)(styles, props),
        namespace: 'card-tile-hero'
      })
    ),
    showModal && _react2.default.createElement(_ApplyModal2.default, {
      styles: styles,
      closeModal: closeModal,
      dtmHelper: dtmHelper
    })
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasHeroBannerData: selectors.getHasHeroBannerData(state),
    cardImage: selectors.getCardImage(state),
    background: selectors.getBackground(state),
    cardTypeLabel: selectors.getCardTypeLabel(state),
    cardType: selectors.getCardType(state),
    heroAnnualFeeLabel: selectors.getHeroAnnualFeeLabel(state),
    heroBonusOfferLabel: selectors.getHeroBonusOfferLabel(state),
    heroSuppAnnualFeeLabel: selectors.getHeroSuppAnnualFeeLabel(state),
    cardAnnualFee: selectors.getCardAnnualFee(state),
    suppAnnualFee: selectors.getSuppAnnualFee(state),
    bonusOffer: selectors.getCardOffer(state),
    cardTitle: selectors.getCardTitle(state),
    cardDesc: selectors.getCardDesc(state),
    primaryButton: selectors.getPrimaryButton(state),
    secondaryButton: selectors.getSecondaryButton(state),
    termAndConditionsLink: selectors.getTermAndConditionsLink(state),
    phoneNumberLink: selectors.getPhoneNumberLink(state),
    cardShortName: selectors.getCardShortName(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CardDetailsHeroBannerBusiness);